/** Cross-origin iframe embed policy (probed via X-Frame-Options / CSP frame-ancestors). */
export type EmbedPolicy = 'allowed' | 'blocked';

export interface EmbedAppConfig {
  id: string;
  appId: string;
  title: string;
  route: string;
  /** When blocked, reason shown in UI */
  blockReason?: string;
}

export const EMBED_APPS: EmbedAppConfig[] = [
  {
    id: 'erp',
    appId: 'erpnext',
    title: 'ERPNext',
    route: '/embed/erp',
    blockReason: 'X-Frame-Options: SAMEORIGIN',
  },
  {
    id: 'crm',
    appId: 'twenty',
    title: 'Twenty CRM',
    route: '/embed/crm',
  },
  {
    id: 'sign',
    appId: 'documenso',
    title: 'Documenso',
    route: '/embed/sign',
  },
  {
    id: 'invoices',
    appId: 'solidinvoice',
    title: 'SolidInvoice',
    route: '/embed/invoices',
    blockReason: 'X-Frame-Options: SAMEORIGIN',
  },
  {
    id: 'docs',
    appId: 'paperless',
    title: 'Paperless',
    route: '/embed/docs',
    blockReason: 'X-Frame-Options: SAMEORIGIN',
  },
  {
    id: 'files',
    appId: 'ocis',
    title: 'oCIS Files',
    route: '/embed/files',
    blockReason: "X-Frame-Options: SAMEORIGIN; CSP frame-ancestors 'self'",
  },
  {
    id: 'flows',
    appId: 'n8n',
    title: 'n8n Flows',
    route: '/embed/flows',
    blockReason: 'X-Frame-Options: SAMEORIGIN',
  },
];

const BLOCKED = new Set(['erpnext', 'solidinvoice', 'paperless', 'ocis', 'n8n']);

export function embedPolicyForApp(appId: string): EmbedPolicy {
  return BLOCKED.has(appId) ? 'blocked' : 'allowed';
}

export function getEmbedConfigByRoute(route: string): EmbedAppConfig | undefined {
  return EMBED_APPS.find((e) => e.route === route);
}

export function getEmbedConfigByAppId(appId: string): EmbedAppConfig | undefined {
  return EMBED_APPS.find((e) => e.appId === appId);
}

/** Sandbox attrs for embedded third-party apps (internal tool only). */
export const IFRAME_SANDBOX =
  'allow-scripts allow-same-origin allow-forms allow-popups allow-downloads allow-modals';
